import {Component, Inject} from '@angular/core';
import {MatSnackBar} from '@angular/material';
import { MAT_SNACK_BAR_DATA } from '@angular/material';
import {
  NotifyType,
  NOTIFY_TYPE_DANGER,
  NOTIFY_TYPE_DEFAULT,
  NOTIFY_TYPE_SUCCESS,
  NOTIFY_TYPE_WARNING
} from './notify-types';

@Component({
  selector: 'atn-notify',
  templateUrl: 'notify.component.html',
  host: {
    '[class]': 'className'
  },
})
export class NotifyComponent {

  get className(): String {
    switch (this.data.type) {
      case NOTIFY_TYPE_DANGER:
        return 'danger';
      case NOTIFY_TYPE_WARNING:
        return 'warning';
      case NOTIFY_TYPE_SUCCESS:
        return 'success';
      default:
      return 'default';
    }
  }

  get icon(): String {
    switch (this.data.type) {
      case NOTIFY_TYPE_DANGER:
        return 'error';
      case NOTIFY_TYPE_WARNING:
        return 'warning';
      case NOTIFY_TYPE_SUCCESS:
        return 'offline_pin';
      default:
        return 'stars';
    }
  }

  get message(): String {
    return this.data.msg;
  }
  constructor(
    private snackBar: MatSnackBar,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  close() {
    this.snackBar.dismiss();
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/notify/notify.component.ts